const styles = {
  banner: {
    backgroundColor: "#fff2f2",
    px: 2,
    py: 1,
    borderRadius: 4,
    my: 2,
    fontSize: 12,
    "& > *": {
      fontSize: 12,
    },
  },
};

export default styles;
